export const socialNetworks = {
    EMAIL: {
        name: 'email',
        icon: 'btEmail',
        urlTemplate: 'mailto:?subject=_TEXT_!&body=_TEXT_SHORT_: _URL_'
    },
    FACEBOOK: {
        name: 'facebook',
        icon: 'btFacebook',
        urlTemplate: `https://www.facebook.com/sharer/sharer.php?u=_URL_`
    },
    TWITTER: {
        name: 'twitter',
        icon: 'btTwitter',
        urlTemplate: 'https://twitter.com/intent/tweet?url=_URL_&text_TEXT_'
    },
    TELEGRAM: {
        name: 'telegram',
        icon: 'btTelegram',
        urlTemplate: 'https://t.me/share/url?url=_URL_&text=_TEXT_'
    },
    WHATSAPP: {
        name: 'whatsapp',
        icon: 'btWhatsapp',
        urlTemplate: 'https://api.whatsapp.com/send?text=_TEXT_ _URL_'
    }
}

export const socialNetworksList = Object.values(socialNetworks)